import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppConfig } from '../app.config';

@Injectable({
  providedIn: 'root'
})

export class MailChimpService {

  constructor(private http: HttpClient, private appConfig:AppConfig) { } 

  get serviceURL():string {
    return this.appConfig.getConfig("mailchimp_subscribe_service_url") + '/post-json?u=' + this.appConfig.getConfig("mailchimp_user_id") + '&id=' + this.appConfig.getConfig("mailchimp_audience_id");
  }
  get idParam():string{
    return 'b_' + this.appConfig.getConfig("mailchimp_user_id") + '_' + this.appConfig.getConfig("mailchimp_audience_id") //check if the b_ is correct for both parameters
  }
  
  public subscribeToList(data:any) {
    const params = new HttpParams()
      .set('EMAIL', data.email)
      .set(this.idParam, '');    
    const mailChimpUrl = `${this.serviceURL}&${params.toString()}`;
    return this.http.jsonp(mailChimpUrl, 'c');
  }
}